function normalizeDate(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0); // force minuit local
  return d;
}

export function getPeriodeInfo(contacts, periodes, locale = "fr-FR", periodePrivilegiee = null) {
  if (!Array.isArray(contacts) || contacts.length === 0) return null;
  if (!Array.isArray(periodes) || periodes.length === 0) return null;

  // Totaux par période (_id)
  const totals = periodes.map((periode) => {
    const periodeId = periode._id;
    return contacts.reduce((sum, c) => {
      const vote = c.periodes?.find(p => p.periodeId === periodeId);
      const val = Number(vote?.valeur || 0);
      return sum + val;
    }, 0);
  });

  const max = Math.max(...totals);
  if (max <= 0) return null;

  // 👉 Trouver toutes les périodes qui atteignent le max
  const maxIndexes = totals
    .map((val, idx) => (val === max ? idx : -1))
    .filter(idx => idx !== -1);

  // Clés dominantes = les vrais _id
  const dominantKeys = maxIndexes.map(i => periodes[i]._id);

  // ✅ Cas simple : une seule dominante
  if (dominantKeys.length === 1) {
    const maxIndex = maxIndexes[0];
    const periodeInfo = periodes[maxIndex];
    if (!periodeInfo) return null;

    const filteredContacts = contacts.filter(c => {
      const vote = c.periodes?.find(p => p.periodeId === periodeInfo._id);
      const val = Number(vote?.valeur || 0);
      return val > 0;
    });

    const startDate = normalizeDate(periodeInfo.start);
    const endDate = normalizeDate(periodeInfo.end);

    return {
      index: maxIndex,
      dominantKey: periodeInfo._id,
      dominantKeys,
      totalCombien: totals[maxIndex],
      totalContacts: filteredContacts.length,
      filteredContacts,
      dates: {
        start: startDate.toISOString(),
        end: endDate.toISOString(),
        localStart: startDate.toLocaleDateString(locale, { day: "2-digit", month: "long", year: "numeric" }),
        localEnd: endDate.toLocaleDateString(locale, { day: "2-digit", month: "long", year: "numeric" }),
        rawStart: startDate,
        rawEnd: endDate
      }
    };
  }

      // ✅ Cas égalité : utiliser periodePrivilegiee si dispo
  if (periodePrivilegiee) {
    const idx = periodes.findIndex(p => p._id === periodePrivilegiee);
    if (idx !== -1) {
      const periodeInfo = periodes[idx];
      const filteredContacts = contacts.filter(c => {
        const vote = c.periodes?.find(p => p.periodeId === periodeInfo._id);
        return Number(vote?.valeur || 0) > 0;
      });

      const startDate = normalizeDate(periodeInfo.start);
      const endDate = normalizeDate(periodeInfo.end);

      return {
        index: idx,
        dominantKey: periodeInfo._id,
        dominantKeys,
        totalCombien: totals[idx],
        totalContacts: filteredContacts.length,
        filteredContacts,
        dates: {
          start: startDate.toISOString(),
          end: endDate.toISOString(),
          localStart: startDate.toLocaleDateString(locale, { day: "2-digit", month: "long", year: "numeric" }),
          localEnd: endDate.toLocaleDateString(locale, { day: "2-digit", month: "long", year: "numeric" }),
          rawStart: startDate,
          rawEnd: endDate
        }
      };
    }
  }

  return {
    dominantKey: null,
    dominantKeys,
    totals,
  };
}

export function getDominantPeriodes(periodes, dominantKeys) {
  if (!Array.isArray(periodes) || !Array.isArray(dominantKeys)) return [];

  return periodes
    .filter(p => dominantKeys.includes(p._id))
    .map(p => ({
      _id: p._id,
      start: p.start,
      end: p.end
    }));
}

